import { InfiniteData, UseInfiniteQueryResult } from '@tanstack/react-query';

import { Checked2 } from '@uikit/icons/Checked2';
import { Clock } from '@uikit/icons/Clock';
import { CloseCircle } from '@uikit/icons/CloseCircle';

import { MagicWallCard, Sorts, TabsID, WallResponse } from '@shared/api/types/magicWall';

import MagicOrderWallActivity from './MagicOrderWallActivity';
import MagicOrderWallOffersPage from './MagicOrderWallOffersPage';

export const DEFAULT_FILTER = 'index';

export type Sort = { id: Sorts; name: string };

enum Categories {
  socialMedia = 'SOCIAL_MEDIA',
  contentCreation = 'CONTENT_CREATION',
  vote = 'VOTE',
  bounty = 'BOUNTY',
  airdrop = 'AIRDROP',
  msqTasks = 'MSQ_TASKS',
  learn2earn = 'LEARN2EARN',
}

export const OFFER_STATUS_CONFIG = {
  APPROVED: {
    label: 'Completed',
    Icon: Checked2,
    className: 'text-green-700',
  },
  REJECTED: {
    label: 'Rejected',
    Icon: CloseCircle,
    className: 'text-red-600',
  },
  PENDING: {
    label: 'In Review',
    Icon: Clock,
    className: 'text-yellow-600',
  },
} as const;

export const extraFilters = {
  id: 0,
  type: 'HOT_OFFER_CATEGORY',
  attributes: {
    key: 'all',
    name: 'All',
  },
};

export const sortTypes: Sort[] = [
  {
    id: 'index',
    name: 'All',
  },
  {
    id: 'date_asc',
    name: 'Oldest',
  },
  {
    id: 'date_desc',
    name: 'Newest',
  },
  {
    id: 'sqr_desc',
    name: 'Highest SQR',
  },
  {
    id: 'sqr_asc',
    name: 'Lowest SQR',
  },
  {
    id: 'karma_desc',
    name: 'Highest Karma',
  },
  {
    id: 'karma_asc',
    name: 'Lowest Karma',
  },
];

export type Tabs = {
  id: keyof typeof TabsID;
  label: string;
  Component: React.ComponentType<{
    query: UseInfiniteQueryResult<InfiniteData<WallResponse, unknown>, unknown>;
    list: MagicWallCard[];
    sort: Sorts;
    setSort: (value: Sorts) => void;
    categoryFilter: string;
    setCategoryFilter: (value: string) => void;
  }>;
};

export const tabs: Array<Tabs> = [
  {
    id: TabsID.Tasks,
    label: 'Tasks',
    Component: MagicOrderWallOffersPage,
  },
  {
    id: TabsID.Activity,
    label: 'Activity',
    Component: MagicOrderWallActivity,
  },
];

export const icons = {
  [Categories.socialMedia]: '/store/wall/icons/social.png',
  [Categories.contentCreation]: '/store/wall/icons/content_creation.png',
  [Categories.vote]: '/store/wall/icons/vote.png',
  [Categories.bounty]: '/store/wall/icons/bounties.png',
  [Categories.airdrop]: '/store/wall/icons/airdrop.png',
  [Categories.msqTasks]: '/store/wall/icons/magic_store_tasks.png',
  [Categories.learn2earn]: '/store/wall/icons/learn2earn.png',
  default: '/store/wall/icons/content_creation.png',
};
